import { render, staticRenderFns } from "./ConstructionTeamDetail.vue?vue&type=template&id=6e7b2f4a&scoped=true"
import script from "./ConstructionTeamDetail.vue?vue&type=script&lang=js"
export * from "./ConstructionTeamDetail.vue?vue&type=script&lang=js"
import style0 from "./ConstructionTeamDetail.vue?vue&type=style&index=0&id=6e7b2f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b2f4a",
  null
  
)

export default component.exports